import React from 'react';

import {NavLink} from "react-router-dom";
import {BsInfoCircle, GiCog, RiRemoteControlLine} from "react-icons/all";

const Navbar = () => {

    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-primary-color nav-bar-app">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><RiRemoteControlLine  className='nav-icon'/></div>
                    <span className="text-small-2 ">ریموت</span>
                </NavLink>
     {/*           <NavLink className="nav-item nav-link  " to="/device">
                    <div><DiHtml5DeviceAccess  className='nav-icon' /></div>
                    <span className="text-small-2 ">دستگاه</span>
                </NavLink>*/}
                <NavLink className="nav-item nav-link  " to="/configs">
                    <div><GiCog className='nav-icon' /></div>
                    <span className="text-small-2"> تنظیمات </span>
                </NavLink>
{/*                <NavLink className="nav-item nav-link  " to="/advanced-setting">
                    <div><MdOutlineSettingsSuggest className='nav-icon' /></div>
                    <span className="text-small-2"> پیشرفته </span>
                </NavLink>*/}
{/*                <NavLink className="nav-item nav-link  " to="/notification">
                    <div><FontAwesomeIcon className='nav-icon' icon={faNewspaper}/></div>
                    <span className="text-small-2"> اینترنت </span>
                </NavLink>*/}
                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><BsInfoCircle className='nav-icon' /></div>
                    <span className="text-small-2"> تلکارنت </span>
                </NavLink>
            </nav>
        </React.Fragment>
    );
};

export default Navbar;
